<template>
	<div class="app-container">
		<div class="header">
			<el-input size="medium" v-model="search" :placeholder="this.$t('adminlogmanage.searchhint')" @keyup.enter.native="logSearch()"
				class="search" />
			<el-button icon="el-icon-search" @click="logSearch()" type="primary" class="btnInsert">{{$t('adminlogmanage.searchbtn')}}</el-button>

			<el-button type="success" size="mini" @click="openInsertLog()" class="btnInsert">{{$t('adminlogmanage.insertbtn')}}
			</el-button>
		</div>
		<el-table :data="logs" style="width: 100%">
			<el-table-column :label="this.$t('adminlogmanage.logid')" prop="" width="80px" show-overflow-tooltip>
				<template slot-scope="scope">
					{{scope.row.id}}
				</template>
			</el-table-column>

			<el-table-column :label="this.$t('adminlogmanage.adminname')" prop="username"> </el-table-column>
			<el-table-column :label="this.$t('adminlogmanage.logtype')" prop="type"> </el-table-column>
			<el-table-column :label="this.$t('adminlogmanage.logdetail')" prop="" show-overflow-tooltip>
				<template slot-scope="scope">
					<i slot="reference">{{scope.row.content}}</i>
				</template>
			</el-table-column>
			<el-table-column :label="this.$t('adminlogmanage.createtime')" prop="createTime"> </el-table-column>


			<el-table-column :label="this.$t('adminlogmanage.operate')" prop="">
				<template slot-scope="scope">
					<el-tag type="warning" class="btn" @click="openUpdateLog(scope.row)">{{$t('adminlogmanage.operatemodify')}}</el-tag>
					<el-tag type="danger" class="btn" @click="deleteOneLog(scope.row.id)">{{$t('adminlogmanage.operatedelete')}}</el-tag>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
			:page-sizes="[5, 10, 15, 20]" :page-size="length" layout="total, sizes, prev, pager, next, jumper"
			:total="total" class="pagination">
		</el-pagination>
		<!-- 新增、修改日志框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form :model="logForm">
				<el-form-item :label="this.$t('adminlogmanage.modifylogid')" :label-width="formLabelWidth" v-if="dialogTitle == this.$t('adminlogmanage.modifytitle')">
					<el-input v-model="logForm.id" autocomplete="off" @input="change($event)" disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('adminlogmanage.modifycreatetime')" :label-width="formLabelWidth" v-if="dialogTitle == this.$t('adminlogmanage.modifytitle')">
					<el-input v-model="logForm.createTime" autocomplete="off" @input="change($event)" disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('adminlogmanage.modifylogtype')"  :label-width="formLabelWidth" v-if="dialogTitle == this.$t('adminlogmanage.modifytitle')">
					<el-input v-model="logForm.type" autocomplete="off" @input="change($event)" disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('adminlogmanage.modifylogdetail')" :label-width="formLabelWidth">
					<el-input v-model="logForm.content" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancle()">{{$t('adminlogmanage.insertcancel')}}</el-button>
				<el-button type="primary" @click="toLog()" v-if="dialogTitle == this.$t('adminlogmanage.modifytitle')">{{$t('adminlogmanage.modifymodify')}}</el-button>
				<el-button type="primary" @click="toLog()" v-if="dialogTitle == this.$t('adminlogmanage.inserttitle')">{{$t('adminlogmanage.insertinsert')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				logs: [{
						id: 0,
						creatorId: '',
						type: 0,
						content: '',
						createTime: ''
					},
					{
						id: 0,
						creatorId: '',
						type: 0,
						content: '',
						createTime: ''
					}
				],
				logForm: {
					id: 0,
					creatorId: '',
					type: 0,
					content: '',
					createTime: ''
				},
				search: "",
				length: 5,
				page: 1,
				total: 0,
				dialogWidth: "30%",
				dialogTitle: '新增管理员日志',
				dialogFormVisible: false,
				btnName: '新增',
				formLabelWidth: '120px'
			};
		},
		created() {
			this.reload();
		},
		methods: {
			change(e) {
				this.$forceUpdate();
			},
			reload() {
				let that = this;
				let length = that.length;
				let page = that.page;
				let search = that.search;
				if (search != '') {
					that.getRequest('/tpa-api/log/getAdminLoglist?length=' + length + '&page=' + page + '&username=' +
						search,
						null).then(
						resp => {
							if (resp.code == 200) {
								that.logs = resp.result;
								that.total = resp.total;
								that.logs.forEach(one => {
									if (one.type == 3) {
										one.type = "管理员行为日志";
									}
								});
							}
						});
				} else {
					that.getRequest('/tpa-api/log/getAdminLoglist?length=' + length + '&page=' + page, null).then(
						resp => {
							if (resp) {
								let result = resp.result;
								result.forEach(one => {
									if (one.type == 3) {
										one.type = "管理员行为日志";
									}
								});
								that.logs = result;
								that.total = resp.total;

							}
						});
				}

			},
			// 分页功能
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.length = val;
				this.reload();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.reload();
			},
			cancle() {
				this.dialogFormVisible = false;
				this.reload();
			},
			logSearch() {
				let that = this;
				let length = that.length;
				let page = 1;
				let search = that.search;
				that.getRequest('/tpa-api/log/getAdminLoglist?length=' + length + '&page=' + page + '&username=' + search,
					null).then(
					resp => {
						if (resp.code == 200) {
							that.logs = resp.result;
							that.total = resp.total;
							that.logs.forEach(one => {
								if (one.type == 3) {
									one.type = "管理员行为日志";
								}
							});
						}
					});
			},
			openInsertLog() {
				this.logForm = {};
				this.dialogTitle = this.$t('adminlogmanage.inserttitle');
				this.btnName = '新增';
				this.dialogFormVisible = true;
			},
			openUpdateLog(row) {
				this.logForm.id = row.id;
				this.logForm.creatorId = row.creatorId;
				this.logForm.type = row.type;
				this.logForm.content = row.content;
				this.logForm.createTime = row.createTime;
				this.dialogFormVisible = true;
				this.dialogTitle = this.$t('adminlogmanage.modifytitle');
				this.btnName = '修改';
			},
			deleteOneLog(id) {
				// 跳出确认框
				let that = this;
				that.$confirm('此操作将永久删除该日志信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 发送ajax请求删除数据
					that.deleteRequest('/tpa-api/log/deleteOneLog/' + id, null).then(resp => {
						if (resp.code == 200) {
							// 重新加载
							that.page = 1;
							that.length = 5;
							that.reload();
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: this.$t('notification.cancelinfo')
					});
				});
			},
			toLog() {
				let that = this;
				let btnName = that.btnName;
				let insertData = {
					type: 3,
					content: that.logForm.content
				};
				if (btnName == '新增') {
					that.postRequest('/tpa-api/log/insertOneLog', insertData).then(
						resp => {
							if (resp.code == 200) {
								// 关闭对话框，刷新页面
								that.dialogFormVisible = false;
								that.reload();
							}
						});
				} else if (btnName == '修改') {
					let updateData = {
						logId: that.logForm.id,
						type: 3,
						content: that.logForm.content
					};
					that.putRequest('/tpa-api/log/updateOneLog', updateData).then(
						resp => {
							if (resp.code == 200) {
								// 关闭对话框，刷新页面
								that.dialogFormVisible = false;
								that.reload();
							} else {
								that.dialogFormVisible = false;
							}
						});
				}
			}

		}
	};
</script>
<style scoped>
	.avatar {
		height: 50px;
	}

	.pagination {
		display: flex;
		float: left;
		margin-left: 10px;
		margin-top: 40px;
	}

	.btnInsert {
		margin-left: 50px;
		height: 36px;
		font-size: 10px;
		line-height: 10px;
		float: right;
	}

	.search {
		width: 30%;
		height: 50px;

	}

	.header {
		display: flex;
		flex-direction: row;
	}

	.btn {
		cursor: pointer;
	}
</style>
